<template>
  <div class="flex w-full flex-1 flex-col items-center px-6">
    <div class="flex w-full max-w-[450px] flex-grow flex-col">
      <div class="my-auto text-center">
        <h1 class="font-medium" :class="titleClasses">
          <slot name="heading" />
        </h1>

        <div
          v-if="$slots.body"
          class="mx-auto mt-[24px] max-w-[360px] font-normal text-[16px] leading-[22px] text-gray-800"
        >
          <slot name="body" />
        </div>
      </div>

      <Button class="w-full" variant="primary" size="lg" @click="$emit('next')">
        {{ cta }}
      </Button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { Button } from '@dacr/library'

const props = withDefaults(
  defineProps<{
    cta?: string
    size?: 'md' | 'lg'
  }>(),
  { cta: 'Next', size: 'lg' }
)

defineEmits<{
  (e: 'next'): void
}>()

const titleClasses = computed(() =>
  props.size === 'md'
    ? 'text-[26px] leading-[32px]'
    : 'text-[28px] leading-[34px] tablet-h:text-[32px] tablet-h:leading-[38px]'
)
</script>
